/* eslint-disable import/prefer-default-export */
export const LEARN_AFTER_RIGHT_RESULTS = 'quiz/LEARN_AFTER_RIGHT_RESULTS';
